import React, {Component} from 'react';
import Icon from './Icon';
import './IconWithCaption.css';

export default class IconWithCaption extends Component{

    render(){
        let {className, icon, caption, ...props} = this.props;
        return(
            <div className={'icon-with-caption table inline align-center ' + (this.props.className || '')} {...props}>
                <div><Icon className='icon' icon={this.props.icon} /></div>
                <div><div className='caption'>{this.props.caption || this.props.icon}</div></div>                
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/IconWithCaption.js